import { Component, OnInit, Input,Output ,EventEmitter} from '@angular/core';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { GlobalService } from '../../../global.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertasComponent } from '../../../alertas/alertas.component';
@Component({
  selector: 'app-register-subscriber',
  templateUrl: './register-subscriber.component.html',
  styleUrls: ['./register-subscriber.component.sass']
})
export class RegisterSubscriberComponent implements OnInit {

  public txtType;
  @Input()  viewSession;
  private  subscriber;
  private  accountType;
  private  accountSubType;

  @Output() updateView = new EventEmitter<number>();
  @Output() updateText = new EventEmitter<any>();
  @Output() updateSub = new EventEmitter<any>();
  @Output() updateAccountType = new EventEmitter<any>();
  @Output() updateAccountSubType = new EventEmitter<any>();

  constructor(private loadingScreenService :LoadingScreenService ,private services: Service,private global:GlobalService,public dialog:MatDialog) { }

  ngOnInit() {}
  submitForm() {
      if (this.subscriber.toString().length != 10) {
          this.global.notif("Debe ingresar un número de suscriptor válido.");
      }
      else {
          if (this.subscriber.toString().match(/[0-9]{10}/)) {
              this.loadingScreenService.startLoading();
              this.services.validateSubscriber(this.subscriber.toString()).subscribe(data =>{
                this.loadingScreenService.stopLoading();
                if(data.hasError ==false){
                    this.accountType = data.accountType;
                    this.accountSubType = data.accountSubType;
                    this.txtType = this.global.checkTypeAccount(this.accountType, this.accountSubType);
                    this.updateText.emit(this.txtType);
                    this.viewSession = 2;
                    this.updateView.emit(this.viewSession);
                    this.updateText.emit(this.txtType);
                    this.updateSub.emit(this.subscriber);
                    this.updateAccountType.emit(this.accountType);
                    this.updateAccountSubType.emit(this.accountSubType);
              }
              else{

                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.data = {message:data.errorDisplay,messageHtml:true};
                this.dialog.open(AlertasComponent, dialogConfig);

              }
            });
          } else {
            this.global.notif("Debe ingresar un número de suscriptor válido.");
            this.loadingScreenService.stopLoading();
          }
      }
  }
}
